import { useState } from "react"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/@/components/ui/dialog"
import v2_actionCriarCalendario from "src/actions/v2/calendario/v2_actionCriarCalendario"
import { CALENDARIOS_DESIGN as D } from "../Calendarios.design"

export function ModalNovoCalendario({
  user,
  isEdit,
  open,
  onOpenChange,
  onCallback
}) {
  const [source, setSource] = useState('lais');
  const [name, setName] = useState('');

  async function handleCreateCalendar() {
    if (!name.trim()) return;
    try {
      const data = {
        scope: {
          name: name.trim(),
          source,
        }
      }
      const response = await v2_actionCriarCalendario(user.clienteId, data)
      if (response.status === 200) {
        onOpenChange?.(false);
        setName('');
        setSource('lais');
        onCallback(response.data.data._id)
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[480px] bg-white border border-[#e7e7ec] rounded-[12px] p-[26px]">
        <DialogHeader>
          <DialogTitle className={D.dialogTitle}>
            {isEdit ? "Editar calendário" : "Novo calendário"}
          </DialogTitle>
          <DialogDescription className={D.dialogDesc}>
            Escolha o nome e se a agenda fica na Lais ou no Google.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-5 py-2">
          <div className={D.field}>
            <label className={D.label}>Nome</label>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Ex: Comercial, Plantão"
              className={D.input}
            />
            <p className={D.hint}>Como este calendário aparece para a equipe.</p>
          </div>
          <div className={D.field}>
            <label className={D.label}>Fonte</label>
            <div className={D.choiceGrid}>
              {[
                { value: 'lais', title: 'Lais', help: 'Agenda gerenciada na plataforma.' },
                { value: 'google', title: 'Google Calendar', help: 'Sincroniza com a agenda do Google.' },
              ].map((opt) => {
                const on = source === opt.value;
                return (
                  <button
                    key={opt.value}
                    type="button"
                    onClick={() => setSource(opt.value)}
                    className={`${D.choiceCard} ${on ? D.choiceCardOn : D.choiceCardOff}`}
                  >
                    <span className={`${D.choiceTitle} ${on ? D.choiceTitleOn : D.choiceTitleOff}`}>
                      {opt.title}
                    </span>
                    <p className={D.choiceHelp}>{opt.help}</p>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
        <DialogFooter className={D.dialogFooter}>
          <button type="button" onClick={() => onOpenChange?.(false)} className={D.ghostButton}>
            Cancelar
          </button>
          <button
            type="button"
            onClick={handleCreateCalendar}
            disabled={!name.trim()}
            className={D.primaryButton}
          >
            {isEdit ? "Salvar" : "Criar"}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
